import { Link } from 'react-router-dom';
import LegalPage, { MailLink, OPERATOR, Section } from './LegalPage';

const linkClass = 'text-primary underline-offset-4 hover:underline';

const Terms = () => (
  <LegalPage
    title="Terms of Service"
    description="Terms of service for using KZcomp.com."
    path="/terms"
  >
    <Section title="1. Scope">
      <p>
        These terms govern the use of KZcomp.com and related KZCOMP services, including user
        accounts, tournaments, community features and our Discord integration. The website is
        operated by {OPERATOR.name} (see{' '}
        <Link to="/imprint" className={linkClass}>
          Legal Notice
        </Link>
        ). By using the website or creating an account, you agree to these terms.
      </p>
    </Section>

    <Section title="2. User accounts">
      <p>
        You must provide accurate information and keep your login credentials confidential. Each
        person may only hold one account. You are responsible for activities carried out through
        your account.
      </p>
    </Section>

    <Section title="3. Acceptable use">
      <p>When using our services, you must not:</p>
      <ul className="list-disc space-y-1 pl-5">
        <li>violate applicable law or the rights of others,</li>
        <li>post insulting, discriminatory, threatening or otherwise offensive content,</li>
        <li>cheat, manipulate results or submit falsified runs, times or demos,</li>
        <li>impersonate other players or staff members,</li>
        <li>
          attempt to disrupt the website, gain unauthorized access, or scrape it in a way that
          impairs its operation.
        </li>
      </ul>
    </Section>

    <Section title="4. Tournaments and competitions">
      <p>
        Participation in tournaments is subject to the{' '}
        <Link to="/rules" className={linkClass}>
          general rules
        </Link>{' '}
        and the specific rules published for each tournament, which take precedence over these
        terms. Organizers may disqualify participants who breach the rules. Any prizes are awarded
        as described in the respective tournament announcement; there is no legal entitlement to
        hold a tournament or to a particular prize beyond what has been announced.
      </p>
    </Section>

    <Section title="5. Content you submit">
      <p>
        You retain the rights to content you submit (e.g. profile information, runs, maps,
        messages). You grant us a free, non-exclusive right to store, display and publish this
        content on KZcomp.com and our associated channels (e.g. Discord, Twitch, YouTube) to the
        extent necessary to operate our services, including tournament results and broadcasts. You
        confirm that you hold the necessary rights to the content you submit.
      </p>
    </Section>

    <Section title="6. Streams and recordings">
      <p>
        KZCOMP tournaments and events may be broadcast live on Twitch and published as recordings on
        YouTube. By participating in a broadcast event, you agree that your username, in-game
        actions and, where applicable, voice communication may be shown in these broadcasts and
        recordings.
      </p>
    </Section>

    <Section title="7. Moderation, suspension and termination">
      <p>
        We may remove content and temporarily or permanently suspend accounts that violate these
        terms, the rules or applicable law. You may delete your account or ask us to delete it at
        any time.
      </p>
    </Section>

    <Section title="8. Availability">
      <p>
        We do not guarantee that the website is available at any particular time. Features may be
        changed or discontinued at any time.
      </p>
    </Section>

    <Section title="9. Liability">
      <p>
        We are liable without limitation for intent and gross negligence, for injury to life, body
        or health, and under the German Product Liability Act. For slight negligence, we are only
        liable for breaches of essential obligations whose fulfilment is necessary for the proper
        use of the service, and limited to the foreseeable damage typical for this type of service.
        Otherwise, liability is excluded.
      </p>
    </Section>


    <Section title="10. Changes to these terms">
      <p>
        We may amend these terms for valid reasons, such as changes to our services or the legal
        situation. If you continue to use the service after the changes take effect, the amended
        terms apply.
      </p>
    </Section>

    <Section title="11. Governing law and contact">
      <p>
        German law applies, excluding the UN Convention on Contracts for the International Sale of
        Goods. For consumers, this choice of law applies only insofar as it does not deprive them of
        the protection of mandatory provisions of the law of their country of habitual residence.
        Should any provision of these terms be invalid, the validity of the remaining provisions
        remains unaffected.
      </p>
      <p>
        Questions about these terms: <MailLink />
      </p>
    </Section>
  </LegalPage>
);

export default Terms;
